<div class = "ui-nav-bar-system-container">
    <div class = "ui-panel-green">
        <i class = "ui-icon uii-genos"></i>
    </div>
    <span class = "ui-nav-bar-system">Genos</span>
</div>
<div class = "ui-nav-bar-states-container">
    <div [ngClass] = "{
        'ui-nav-bar-state': true,
        'ui-nav-bar-state-selected': state.path === actualState?.path
    }" *ngFor = "let state of states.main">
        <a class = "ui-button" [routerLink] = "state.path">
            <i [class] = "state.icon" [style.font-size] = "state.fontSize"></i>
            <span class = "ui-button-label">{{ state.name }}</span>
        </a>
        <div class = "ui-nav-bar-state-bar"></div>
    </div>
    <div [ngClass] = "{
        'ui-nav-bar-state': true,
        'ui-nav-bar-state-selected': state.path === actualState?.path
    }" *ngFor = "let state of states.management">
        <a class = "ui-button" [routerLink] = "state.path" [matTooltip] = "state.name">
            <i [class] = "state.icon" [style.font-size] = "state.fontSize"></i>
            <span class = "ui-button-label">{{ state.name }}</span>
        </a>
        <div class = "ui-nav-bar-state-bar"></div>
    </div>
</div>
<div class = "ui-nav-bar-user-container">
    <app-notification></app-notification>
    <button class = "ui-button" [mat-menu-trigger-for] = "userMenu">
        <img class = "ui-nav-bar-user-photo" [src]="user.detail.profilePhoto" alt="Imagem do usuário">
        <span class = "ui-button-label">{{ user.name.split(' ')[0] }}</span>
    </button>
</div>

<mat-menu #userMenu = "matMenu" class = "ui-menu">
    <div class = "ui-menu-container">
        <div class = "ui-user-info">
            <div class = "ui-user-info-photo">
                <img [src] = "user.detail.profilePhoto">
            </div>
            <div class = "ui-detail-container">
                <span class = "ui-title">{{ user.name }}</span>
                <span class = "ui-sub-title">{{ user.detail.document.number }}</span>
            </div>
        </div>
        <div class = "ui-divisor"></div>
        <div class = "ui-menu-options">
            <a class = "ui-button ui-menu-option" routerLink = "iam/user">
                <i class = "ui-icon uii-gear"></i>
                <span class = "ui-button-label">Configurações</span>
            </a>
        </div>
        <div class = "ui-divisor"></div>
        <div class = "ui-menu-options">
            <button class = "ui-button ui-menu-option ui-red" (click) = "eventSignOut()">
                <i class = "ui-icon uii-logout"></i>
                <span class = "ui-button-label">Sair</span>
            </button>
        </div>
        <span class = "ui-version">{{ version }}</span>
    </div>
</mat-menu>
